module.exports = __webpack_public_path__ + "img/3_14.4eb5d421.jpg";